import React from "react";

const AddIcon = () => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6 2.125C6.20711 2.125 6.375 2.29289 6.375 2.5V5.625H9.5C9.70711 5.625 9.875 5.79289 9.875 6C9.875 6.20711 9.70711 6.375 9.5 6.375H6.375V9.5C6.375 9.70711 6.20711 9.875 6 9.875C5.79289 9.875 5.625 9.70711 5.625 9.5V6.375H2.5C2.29289 6.375 2.125 6.20711 2.125 6C2.125 5.79289 2.29289 5.625 2.5 5.625H5.625V2.5C5.625 2.29289 5.79289 2.125 6 2.125Z"
        fill="#2B244C"
      />
    </svg>
  );
};

export default AddIcon;
